module.exports = __webpack_public_path__ + "fonts/Poppins-LightItalic.926a872e.ttf";